<template>
    <div>


        <!-- Modal -->
        <div class="modal fade" id="addCarrinhoClone" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" >Promoção - Clones</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form>
                    <div v-if="form.produtos.length<clone.quantidade" class="modal-body">


                        <section class="title" >
                            <h2>Escolha a {{form.produtos.length+1}}ª Pizza</h2>
                        </section>


                        <!-- Sabores -->
                            <div
                                class="card my-3 p-3 d-flex flex-colunm">
                                <div class="row">
                                    <div class="col text-center">
                                        <h5>Sabor:</h5>
                                        <p>Nesta pizza você pode escolher {{clone.tamanho.qms==1?'apenas':'até'}} {{clone.tamanho.qms}} {{clone.tamanho.qms==1?'sabor':'sabores'}} </p>
                                    </div>
                                </div>
                                <div class="row" >
                                    <table class="table">
                                        <tbody>
                                            <tr
                                                v-for="(sabor, index) in pizzaAtiva.sabores"
                                                :key="index"
                                            >
                                                <td scope="row">
                                                    <div v-if="sabor.imagem" class="p-1 align-self-center">
                                                        <img class="img-thumb" :src="sabor.imagem" style="max-height: 72px ; max-width: 72px" >
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="p-1">
                                                        <h6>{{sabor.nome}}</h6>
                                                        <span style="font-weight:normal; font-size:12px">{{sabor.descricao}}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <a class="btn btn-danger" href="#" @click="pizzaAtiva.sabores.splice(index, 1)" >Excluir</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="pizzaAtiva.sabores.length<clone.tamanho.qms" class="form-group row">
                                    <div class="col text-center">
                                        <a class="btn b-btn" @click="modalEscolherSabor()"  href="#"> Escolher {{pizzaAtiva.sabores.length>0?'outro':''}} Sabor </a>
                                    </div>
                                </div>


                            </div>

                            <!-- Bordas -->

                            <div v-if="!isEmpty&&clone.bordas.length>0" class="card my-3 p-3 d-flex flex-colunm">
                                <div class="text-center mb-3">
                                    <h5>Tipo de borda:</h5>
                                </div>
                                <div
                                    v-for="borda in clone.bordas" :key="borda.id"
                                    class="d-flex flex-row my-1"
                                >
                                    <template v-if="borda.disponivel==1">

                                        <div class="d-inline custom-control custom-switch ml-3">

                                            <input type="radio"
                                                :id="'bordac-'+borda.id"
                                                :value="borda"
                                                name="bordac"
                                                v-model="pizzaAtiva.borda"
                                                class="custom-control-input"
                                            >
                                            <label :for="'bordac-'+borda.id" class="custom-control-label">{{borda.nome}}</label>
                                        </div>

                                        <div class="ml-auto">
                                            <div style="width:110px; text-align: center ">
                                                <span >+ {{borda.valor}}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>


                            <!-- Massa -->

                            <div v-if="!isEmpty&&clone.massas.length>0" class="card my-3 p-3 d-flex flex-colunm">
                                <div  class="text-center mb-3">
                                    <h5>Tipo de Massa:</h5>
                                </div>
                                <div
                                    v-for="massa in clone.massas" :key="massa.id"
                                    class="d-flex flex-row my-1"
                                >
                                    <template v-if="massa.disponivel==1">

                                        <div class="d-inline custom-control custom-switch ml-3">

                                            <input type="radio"
                                                :id="'massac-'+massa.id"
                                                :value="massa"
                                                name="massac"
                                                v-model="pizzaAtiva.massa"
                                                class="custom-control-input"
                                            >
                                            <label :for="'massac-'+massa.id" class="custom-control-label">{{massa.nome}}</label>
                                        </div>


                                        <div class="ml-auto">
                                            <div style="width:110px; text-align: center ">
                                                <span >+ {{massa.valor}}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>


                            <!-- Adicionais -->

                            <div v-if="!isEmpty && clone.tamanho.adicionais.length>0" class="card my-3 p-3 d-flex flex-colunm">
                                <div class="mb-3 text-center">
                                    <h5>Adicionais:</h5>
                                </div>
                                <div
                                    v-for="adicional in clone.tamanho.adicionais" :key="adicional.id"
                                    class="d-flex flex-row my-1"
                                >
                                    <template >

                                        <div class="d-inline custom-control ">
                                            <p>{{ adicional.nome }}</p>
                                        </div>


                                        <div class="ml-auto">
                                            <div style="width:110px; text-align: center ">
                                                <span >+ {{adicional.valor}}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>





                            <!-- OBS -->

                            <div class="card my-3 p-3 d-flex flex-colunm">
                                <div class="text-center mb-3">
                                    <h5>Alguma Observação?</h5>
                                </div>
                                <div>
                                    <textarea placeholder="Ex: Sem azeitona" v-model="pizzaAtiva.obs"></textarea>
                                </div>
                            </div>



                    </div>

                    <div class="modal-body" v-else>

                        <section class="title" >
                            <h2>Confirmar</h2>
                        </section>

                        <div
                            class="row"
                            v-for="(pizza, index) in form.produtos"
                            :key="index"
                        >
                            <div class="col">
                                <h4>Pizza {{index+1}}</h4>
                                <p>Sabores: <span class="badge badge-pill badge-success badge-font m-1" v-for="sabor in pizza.sabores" :key="sabor.id" > {{sabor.nome}} </span></p>
                                <p v-if="!estavazio(pizza.borda)">Borda: <span class="badge badge-pill m-1 badge-font" :class="pizza.borda.valor==0?'badge-secondary':'badge-danger'" > {{pizza.borda.nome}} {{pizza.borda.valor==0?'':'+ R$ '+formatarMoeda(pizza.borda.valor)}}</span>  </p>
                                <p v-if="!estavazio(pizza.massa)">Massa: <span class="badge badge-pill m-1 badge-font" :class="pizza.massa.valor==0?'badge-secondary':'badge-danger'" > {{pizza.massa.nome}} {{pizza.massa.valor==0?'':'+ R$ '+formatarMoeda(pizza.massa.valor)}} </span> </p>
                                <p>Adicionais: <span class="badge badge-pill badge-secondary badge-font m-1" v-for="adicional in pizza.adicionais" :key="adicional.id" > {{adicional.nome}} {{adicional.valor==0?'':'+ R$ '+formatarMoeda(adicional.valor)}} </span></p>
                                <p>Obs: {{pizza.obs}}</p>
                                <hr>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col text-center">
                                <h3>Valor:</h3>
                            </div>
                            <div class="col text-center">
                                <h3>R$ {{formatarMoeda(vtotal)}}</h3>
                            </div>
                        </div>



                    </div>



                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <a v-if="form.produtos.length<clone.quantidade" class="btn b-btn" @click="proximaPizza()"  href="#"> Proxima Pizza </a>
                        <a v-else class="btn b-btn" @click="adicionar()"  href="#"> Concluir </a>
                    </div>
                  </form>
                </div>
            </div>


        </div>

        <!-- Modal escolher Sabor -->
        <div class="modal fade" id="escolherSabor2" tabindex="1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" >Escolher Sabor</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form >
                    <div class="modal-body">


                        <div
                            v-for="sabor in clone.produtos"
                            :key="sabor.id"
                            class="row"
                        >


                            <div
                                class="col px-1 my-1 escolherSabor"
                            >
                                <a @click="selecionarSabor(sabor)" >
                                    <div class="card p-2">
                                        <div class="d-flex flex-row" style="height:100%">
                                            <div v-if="sabor.imagem" class="p-1 align-self-center">
                                                <img class="img-thumb" :src="sabor.imagem" style="max-height: 72px ; max-width: 72px" >
                                            </div>
                                            <div class="p-1">
                                                <h6>{{sabor.nome}}</h6>
                                                <span style="font-weight:normal; font-size:12px">{{sabor.descricao}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </a>

                            </div>



                        </div>



                    </div>

                </form>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import api from "../service/api";

export default {
    data () {
        return {
            montarPizza:[],

            pizzas:[],

            adicionais:[],

            pizzaAtiva: new Form({
                sabores: [],
                borda:{},
                massa:{},
                adicionais:[],
                obs:''
            }),

            form: new Form({
                tipo: 3,
                tamanho_id:'',
                clone_id:'',
                nome: '',
                produtos:[],
                valor:0,
                obs: '',
                quantidade: 1,
            }),
        }
    },

    watch: {

        clone: function (clone) {
            this.pizzaAtiva.reset();
            this.pizzaAtiva.errors.errors = {};
            this.pizzaAtiva.adicionais = clone.tamanho.adicionais;
            this.form.produtos=[];
            this.form.nome=clone.nome;
            this.form.tamanho_id=clone.tamanho.id;
            this.form.clone_id=clone.id;
            this.form.valor=clone.valor;
            // this.pizzas=[];
        },

    },

    methods: {


        adicionar() {
            let obj1 = JSON.parse(JSON.stringify(this.form));

            this.$store.dispatch('adicionarProduto', obj1).then();
            $('#addCarrinhoClone').modal('hide');


            Toast.fire({
                icon: 'success',
                title: "Item Adicionado no Carrinho"
            });

            fbq('track', 'AddToCart', {
                content_name: this.clone.nome+" Pizza "+this.clone.tamanho.nome,
                content_type: 'clone',
                quantity: this.form.quantidade,
                value: this.vtotal,
                currency: 'BRL'
            });

            this.form.reset();
        },

        estavazio(objeto){
            return Object.keys(objeto).length === 0 && objeto.constructor === Object
        },


        formatarMoeda(valor){
              return valor.replace(".",",")
        },

        async modalEscolherPizza(){
            // let obj1 = JSON.parse(JSON.stringify(prod));
            // await this.$store.dispatch('atualizarProdutoAtivo', obj1).then();
            // await this.$store.dispatch('showModalAddCarrinho').then();

            $('#addCarrinhoClone').modal('hide');

            setTimeout(function() {
                $('#addCarrinhoClonePizza').modal('show').on('hidden.bs.modal', function (e) {
                    $('#addCarrinhoClone').modal('show');
                })
            }, 400);

        },

        async modalEscolherSabor(){
            // let obj1 = JSON.parse(JSON.stringify(prod));
            // await this.$store.dispatch('atualizarProdutoAtivo', obj1).then();
            // await this.$store.dispatch('showModalAddCarrinho').then();

            $('#addCarrinhoClone').modal('hide');

            setTimeout(function() {
                $('#escolherSabor2').modal('show').on('hidden.bs.modal', function (e) {
                    $('#addCarrinhoClone').modal('show');
                })
            }, 400);

        },

        selecionarSabor(sabor){

            this.pizzaAtiva.sabores.push(sabor);

            $('#escolherSabor2').modal('hide');

        },

        proximaPizza(){


            if (this.pizzaAtiva.sabores.length>0) {

                /* if (!this.estavazio(this.pizzaAtiva.borda)) {

                    if (!this.estavazio(this.pizzaAtiva.massa)) {

                        let obj1 = JSON.parse(JSON.stringify(this.pizzaAtiva));

                        this.form.produtos.push(obj1);

                        $('#addCarrinhoClone').modal('hide');

                        this.pizzaAtiva.reset();
                        this.pizzaAtiva.errors.errors = {};

                        setTimeout(function() {
                            $('#addCarrinhoClone').modal('show')
                        }, 400);

                    }else{

                        Swal.fire({
                            icon: 'error',
                            title: 'Você precisa escolher um tipo de Massa',
                            showConfirmButton: false,
                            timer: 2500
                        });

                    }
                }else{

                    Swal.fire({
                        icon: 'error',
                        title: 'Você precisa escolher um tipo de Borda',
                        showConfirmButton: false,
                        timer: 2500
                    });
                } */

                let obj1 = JSON.parse(JSON.stringify(this.pizzaAtiva));

                this.form.produtos.push(obj1);

                $('#addCarrinhoClone').modal('hide');

                this.pizzaAtiva.reset();
                this.pizzaAtiva.errors.errors = {};
                this.pizzaAtiva.adicionais = this.clone.tamanho.adicionais;

                setTimeout(function() {
                    $('#addCarrinhoClone').modal('show')
                }, 400);


            }else{

                Swal.fire({
                    icon: 'error',
                    title: 'Você precisa escolher pelo menos um sabor',
                    showConfirmButton: false,
                    timer: 2500
                });

               /*  Toast.fire({
                    icon: 'success',
                    title: "Você precisa escolher pelo menos um sabor"
                }); */
            }



        },






    },

    mounted () {
        // this.carregarPizzas();
        // this.resetarPizza(this.pizzaAtiva);
    },


    computed: {

        clone() {
            return this.$store.state.cloneAtivo.main;
        },

        // isEmpty: function() {
        //     return Object.keys(this.formAddCarrinho.tamanho).length === 0 && this.formAddCarrinho.tamanho.constructor === Object;
        // },


        vtotal: function() {

            let valorPizza = parseFloat(this.clone.valor);
            let valorTotal = parseFloat(0);
            let valorAdicionais = parseFloat(0);

            for (let index = 0; index < this.form.produtos.length; index++) {
                valorTotal += parseFloat(this.form.produtos[index].borda.valor||0);
                valorTotal += parseFloat(this.form.produtos[index].massa.valor||0);

                this.form.produtos[index].adicionais.forEach(adicional => {
                    valorAdicionais += parseFloat(adicional.valor||0);
                });
            }


            return (valorPizza+valorTotal+valorAdicionais).toFixed(2);
        }



    }

}
</script>

<style scoped>

.card {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0.07));
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 0.8rem;
}

.card textarea{
    width: 100%;
    height: 100px;
    padding: 5px;
}

.card h5 {
    background-color: var(--btnbg3);
    filter: opacity(0.7);
    padding: 10px;
    border-radius: 10px;
    color: var(--btntxt3);
    text-transform: uppercase;
}

.escolherSabor a{
    text-decoration: none;
    cursor: pointer;
}

.escolherSabor a .card:hover{
    box-shadow: 2px 2px 6px 0px #a7a7a7;
}

.title{
    text-align: center;
}

.title img {
    margin-left: 20px;
    padding: 4px;
    border: 1px solid #9c9c9c;
    border-radius: 2px;
    object-fit: cover;
    box-shadow: 2px 2px 4px 0px #a7a7a7;
}

.qt{
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.20);
    font-size: 1.2rem;
    width: 35px;
    height: 30px;
    text-align: center;
}

.badge-font{
    font-size: initial;
}


.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: var(--btnbg3);
    background-color: var(--btnbg3);
}

</style>
